var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 0C38.8086 0 50 11.1914 50 25C50 38.8086 38.8086 50 25 50C11.1914 50 0 38.8086 0 25C0 11.1914 11.1914 0 25 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7305 25L13.75 31.6016L19.375 34.9023V38.7695L10.4688 33.5547V23.0664L13.7305 25ZM13.7305 18.3984V22.2461L10.4688 20.3125V16.4453L13.7305 14.5117L17.0117 16.4453L13.7305 18.3984ZM21.7188 16.4453L24.9805 14.5117L28.2617 16.4453L25 18.3984L21.7188 16.4453ZM16.1133 30.2344V26.3672L19.375 28.3008V32.1484L16.1133 30.2344ZM21.7188 36.3086L24.9805 38.2422L28.2617 36.3086V40.1562L24.9805 42.0898L21.7188 40.1562V36.3086ZM32.9688 16.4453L36.2305 14.5117L39.5117 16.4453V20.3125L36.2305 22.2461V18.3984L32.9688 16.4453ZM36.25 31.6016L36.2695 25L39.5312 23.0664V33.5547L30.625 38.7695V34.9023L36.25 31.6016ZM33.8867 30.2344L30.625 32.1484V28.3008L33.8867 26.3672V30.2344ZM33.8867 19.7656L33.9063 23.6328L28.2812 26.9336V33.5547L25.0195 35.4688L21.7578 33.5547V26.9336L16.1133 23.6328V19.7656L19.3945 17.832L25 21.1523L30.625 17.832L33.8867 19.7656ZM16.1133 13.1445L25 7.91016L33.9063 13.1445L30.6445 15.0781L25.0195 11.7578L19.3945 15.0781L16.1133 13.1445Z",
    fill: "#F0B90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.1b408912db8262c0a332067647116fdf.svg";
export { ForwardRef as ReactComponent };